import { Reveal } from "@/components/motion/Reveal";
import CountUp from "@/components/motion/CountUp";
import { stats } from "@/data/content";

export default function StatsBand() {
  return (
    <section data-testid="stats-band" className="border-y border-line bg-bone">
      <div className="mx-auto grid max-w-[1600px] grid-cols-2 md:grid-cols-4">
        {stats.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.08}
            className={`border-line px-5 py-10 sm:px-8 sm:py-12 md:px-8 md:py-14 lg:px-10 lg:py-16 xl:px-12 ${i % 2 === 0 ? "border-r" : ""} ${
              i < 2 ? "border-b md:border-b-0" : ""
            } md:[&:not(:last-child)]:border-r`}
          >
            <p className="flex items-start font-display text-5xl font-extrabold leading-none text-ink md:text-7xl">
              <CountUp to={parseInt(s.value, 10)} />
              <span className="ml-1 text-2xl text-accent md:text-3xl">{s.suffix}</span>
            </p>
            <p className="mt-4 text-sm font-medium uppercase tracking-[0.12em] text-muted">{s.label}</p>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
